export function splitHeadingLastWord(text, defaultBefore, defaultHighlight) {
  if (!text?.trim()) {
    return { before: defaultBefore, highlight: defaultHighlight };
  }
  const parts = text.trim().split(/\s+/);
  if (parts.length === 1) {
    return { before: "", highlight: parts[0] };
  }
  const highlight = parts.pop();
  return { before: `${parts.join(" ")} `, highlight };
}
